<div class="container hijo" data-simplebar>
  <div class="row tel-encabezado-pagina">
    <div class="col-12">
      <h3 class="tel-titulo-pagina">
        <strong>{{ 'MENSAJERIA.RECIBIDOS.TITULO' | translate }}</strong>
      </h3>
    </div>
  </div>
  <div class="row">
    <div class="separador"></div>
  </div>

  <div class="row justify-content-center">
    <i class="icon-info"></i>
    <div class="mensaje">
      <div>{{ 'MENSAJERIA.AVISO' | translate }}</div>
      <div>{{ 'MENSAJERIA.AVISO2' | translate }}</div>
    </div>
  </div>

  <div class="row linkNuevoMensaje" *ngIf="permisoEnvioMensaje; else sinPermiso">
    <div class="col-12">
      <i class="icon-mas masNuevoMensaje"></i>
      <div class="nuevoMensaje" (click)="nuevoMensaje()">
        {{ 'MENSAJERIA.NUEVO' | translate }}
      </div>
    </div>
  </div>
  <ng-template #sinPermiso>
    <!-- Contenido alternativo cuando `permisoEnvioMensaje` es false -->
    <div class="row">
      <div class="col-12">
        <div class="alert alert-warning  p-0 p-sm-3">
          <div class="mensaje" >  
            <div>{{'MENSAJERIA.AVISO3'| translate}}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="row tel-cuerpo-pagina col-12" data-simplebar>
    <loader></loader>

    <div
      class="row justify-content-center"
      *ngIf="mensajesRecibidosRecientes.length == 0 && mensajesRecibidosAnteriores.length == 0 && !loader.active"
    >
      <div class="sinDatos col-12">
        <h3>{{ 'MENSAJERIA.RECIBIDOS.SIN_DATOS' | translate }}</h3>
      </div>
    </div>

    <!-- ----------------------------------------------------------------------- -->
    <!--                     MENSAJES EN LOS ULTIMOS 7 DIAS                      -->
    <!-- ----------------------------------------------------------------------- -->
    <div
      class="row justify-content-center mb-4"
      *ngIf="(mensajesRecibidosRecientes.length > 0 || mensajesRecibidosAnteriores.length > 0) && !loader.active"
    >
      <div class="tel-cabecera-grupo">
        <div class="d-flex w-100">
          <h5 class="mb-1">{{ 'MENSAJERIA.RECIENTES' | translate }}</h5>
        </div>
      </div>
      <ng-container *ngIf="mensajesRecibidosRecientes.length > 0; else sinMensajesRecibidosRecientes">
        <ul class="list-group w-100">
          <li
            *ngFor="let mensaje of mensajesRecibidosRecientes"
            class="tel-mensaje list-group-item list-group-item-action flex-column align-items-start"
            [ngClass]="{ leido: mensaje.leido }"
            (click)="leerMensaje(mensaje)"
          >
            <div class="row">
              <i [ngClass]="{ 'icon-mensaje_leido': mensaje.leido, 'icon-mensaje': !mensaje.leido }" class="icono"></i>
              <div class="col">
                  <div class="emisor_mensaje">
                    {{ 'MENSAJERIA.VISUALIZACION.DE' | translate }}:
                    <span *ngIf="mensaje.profesionalNombre !== null&& mensaje.profesionalNombre !== ''">
                      {{ mensaje.profesionalNombre | capitalizado }}
                    </span>
                    <span *ngIf="mensaje.profesionalApellido1 !== null && mensaje.profesionalApellido1 !== ''">
                      {{ mensaje.profesionalApellido1 | capitalizado }}
                    </span>
                    <span *ngIf="mensaje.profesionalApellido2 !== null && mensaje.profesionalApellido2 !== ''">
                      {{ mensaje.profesionalApellido2 | capitalizado }}
                    </span>
                    <span *ngIf="mensaje.profesionalServicio !== null && mensaje.profesionalServicio !== ''" class="servicio_emisor">
                      ({{ mensaje.profesionalServicio | capitalizado }})
                    </span>
                  </div>
                

                <div class="d-flex w-100 h-100 justify-content-between align-items-center" style="gap: 3px;">
                  <div>{{ mensaje.asunto | htmlTexto }} </div>
                  <div class="tel-tiempo-mensaje"> {{ getFechaMensajeFormateada(mensaje.fechaEnvio) }}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </ng-container>
      <ng-template #sinMensajesRecibidosRecientes>
        <p class="sin-mensajes">{{ 'MENSAJERIA.VACIOULTIMOSDIAS' | translate }}</p>
      </ng-template>
    </div>

    <!-- ----------------------------------------------------------------------- -->
    <!--                           MENSAJES ANTERIORES                           -->
    <!-- ----------------------------------------------------------------------- -->
    <div
      class="row justify-content-center"
      *ngIf="(mensajesRecibidosRecientes.length > 0 || mensajesRecibidosAnteriores.length > 0) && !loader.active"
    >
      <div class="tel-cabecera-grupo">
        <div class="d-flex w-100">
          <h5 class="mb-1">{{ 'MENSAJERIA.ANTERIORES' | translate }}</h5>
        </div>
      </div>
      <ng-container *ngIf="mensajesRecibidosAnteriores.length > 0; else sinMensajesRecibidosAnteriores">
        <ul class="list-group w-100">
          <li
            *ngFor="let mensaje of mensajesRecibidosAnteriores"
            class="tel-mensaje list-group-item list-group-item-action flex-column align-items-start"
            [ngClass]="{ leido: mensaje.leido }"
            (click)="leerMensaje(mensaje)"
          >
          <div class="row">
            <i [ngClass]="{ 'icon-mensaje_leido': mensaje.leido, 'icon-mensaje': !mensaje.leido }" class="icono"></i>
            <div class="col">
              <div class="emisor_mensaje">
                {{ 'MENSAJERIA.VISUALIZACION.DE' | translate }}:
                <span *ngIf="mensaje.profesionalNombre !== null&& mensaje.profesionalNombre !== ''">
                  {{ mensaje.profesionalNombre | capitalizado }}
                </span>
                <span *ngIf="mensaje.profesionalApellido1 !== null && mensaje.profesionalApellido1 !== ''">
                  {{ mensaje.profesionalApellido1 | capitalizado }}
                </span>
                <span *ngIf="mensaje.profesionalApellido2 !== null && mensaje.profesionalApellido2 !== ''">
                  {{ mensaje.profesionalApellido2 | capitalizado }}
                </span>
                <span *ngIf="mensaje.profesionalServicio !== null && mensaje.profesionalServicio !== ''" class="servicio_emisor">
                  ({{ mensaje.profesionalServicio | capitalizado }})
                </span>
              </div>
            

              <div class="d-flex w-100 h-100 justify-content-between align-items-center">
                <div>{{ mensaje.asunto | htmlTexto }} </div>
                <div class="tel-tiempo-mensaje"> {{ getFechaMensajeFormateada(mensaje.fechaEnvio) }}</div>
              </div>
            </div>
          </div>
          </li>
        </ul>
      </ng-container>
      <ng-template #sinMensajesRecibidosAnteriores>
        <p class="sin-mensajes">{{ 'MENSAJERIA.VACIOANTERIORES' | translate }}</p>
      </ng-template>
    </div>
  </div>
</div>
